export * from './src/academy-certifications-v1-user-certification-user-certifications.universal.js';
